import { Routes } from '@angular/router';
//import { NgModule } from '@angular/core';
import { UserTableComponent } from './components/user-table/user-table.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { UserManagementComponent } from './components/user-management/user-management.component';
import { LoginComponent } from './components/login/login.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { PageNotFoundComponent } from './components/page-not-found/page-not-found.component';
//import { LayoutComponent } from './components/layout/layout.component';
import { DashboardHomeComponent } from './components/dashboard-home/dashboard-home.component';
import { DashboardShopeeComponent } from './components/dashboard-shopee/dashboard-shopee.component';
import { authGuard } from './guards/auth.guard';
import { adminGuard } from './guards/admin.guard';
import { shopeeDocsGuard } from './guards/shopee-docs.guard';
import { warehouseGuard } from './guards/warehouse.guard';
import { managerGuard } from './guards/manager.guard';
import { roleGuard } from './guards/role.guard';
import { forwardingAdminGuard, forwardingUserGuard } from './guards/forwarding.guard';
import { 
  customsClearanceGuard, 
  repackCreateGuard,
  repackUpdateGuard,
  repackCancelGuard,
  orderManagementGuard as featureOrderManagementGuard
} from './guards/feature.guard';
import { OrderListComponent } from './components/order-list/order-list.component'; // Import OrderListComponent
import { orderManagementGuard } from './guards/order-management.guard'; // Import the new guard
import { OrderDetailComponent } from './components/order-detail/order-detail.component'; // Import OrderDetailComponent
import { RepackCreateComponent } from './components/repack-create/repack-create.component';
import { RepackUpdateComponent } from './components/repack-update/repack-update.component';
import { RepackAddToExistingComponent } from './components/repack-add-to-existing/repack-add-to-existing.component';
import { RepackAddParcelsComponent } from './components/repack-add-parcels/repack-add-parcels.component'; // Import RepackAddParcelsComponent
import { pendingRebindGuard, canDeactivateRepackAddToExisting } from './guards/pending-rebind.guard'; // Import the new guards
import { DocumentListComponent } from './components/document-list/document-list.component'; // Import DocumentListComponent
import { DocumentDetailComponent } from './components/document-detail/document-detail.component'; // Import DocumentDetailComponent
import { DocumentCreateAirLandComponent } from './components/document-create-air-land/document-create-air-land.component'; // Import DocumentCreateAirLandComponent
import { DocumentCreateSeaComponent } from './components/document-create-sea/document-create-sea.component'; // Import DocumentCreateSeaComponent
import { PreAlertList } from './components/pre-alert-list/pre-alert-list';
import { PreAlertDetail } from './components/pre-alert-detail/pre-alert-detail';
import { ManifestComponent } from './components/manifest/manifest.component';
import { TemplateManagementComponent } from './components/template-management/template-management.component';
import { IntegrationManagementComponent } from './components/integration-management/integration-management.component';
import { CustomsClearanceComponent } from './components/customs-clearance/customs-clearance.component';
import { CustomsClearanceProgressComponent } from './components/customs-clearance-progress/customs-clearance-progress.component';
import { SystemHealthComponent } from './components/system-health/system-health.component';
import { SecurityDashboardComponent } from './components/security-dashboard/security-dashboard.component';
import { ExcelUploadDemoComponent } from './components/excel-upload-demo/excel-upload-demo.component';
import { SignalRDemoComponent } from './components/signalr-demo/signalr-demo.component';
import { ResponsiveDemoComponent } from './components/responsive-demo/responsive-demo.component';
import { OfflineDemoComponent } from './components/offline-demo/offline-demo.component';
import { MobileCartonScannerComponent } from './components/mobile-carton-scanner/mobile-carton-scanner.component';
import { ShopeeExcelUploadComponent } from './components/shopee-excel-upload/shopee-excel-upload.component';
import { ForwardingDashboardComponent } from './components/forwarding/forwarding-dashboard/forwarding-dashboard';
import { InquiryListComponent } from './components/forwarding/inquiry-list/inquiry-list';
import { InquiryFormComponent } from './components/forwarding/inquiry-form/inquiry-form';
import { ForwardingAdminComponent } from './components/forwarding/forwarding-admin/forwarding-admin';
import { EditQuoteTemplateComponent } from './components/forwarding/edit-quote-template/edit-quote-template';
import { ForwardingPlaceholderComponent } from './components/forwarding/placeholder/placeholder.component';

export const routes: Routes = [
    {
        path: '', 
        redirectTo: 'login',
        pathMatch: 'full'
    },
    {
        path: 'login', 
        component: LoginComponent
    },    {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [authGuard, pendingRebindGuard], // Protect the dashboard route and check for pending rebinds
        children: [
          { path: '', component: DashboardHomeComponent, title: 'Dashboard Home' }, // Default child route
          { path: 'shopee', component: DashboardShopeeComponent, title: 'Shopee Dashboard', canActivate: [orderManagementGuard] }, // Shopee-specific dashboard
          { path: 'user-management', component: UserManagementComponent, title: 'User Management', canActivate: [adminGuard] }, // Admin only - New combined component
          { path: 'security', component: SecurityDashboardComponent, title: 'Security Dashboard', canActivate: [adminGuard] }, // Admin only - Security dashboard

          // User Preferences (any logged-in user)
          {
            path: 'user-preferences',
            loadComponent: () =>
              import('./components/user-preferences/user-preferences.component').then(
                (m) => m.UserPreferencesComponent
              ),
            title: 'User Preferences',
            canActivate: [authGuard],
          },

          // Keep old routes for backward compatibility (optional)
          { path: 'users', redirectTo: 'user-management', pathMatch: 'full' }, // Redirect old user list route
          { path: 'create-user', redirectTo: 'user-management', pathMatch: 'full' }, // Redirect old create user route
          { path: 'edit-user/:id', redirectTo: 'user-management', pathMatch: 'full' }, // Redirect old edit user route
          // New route for Order List
          { path: 'orders', component: OrderListComponent, title: 'Shopee Orders', canActivate: [orderManagementGuard] }, // List view at /dashboard/orders
          { path: 'orders/:id', component: OrderDetailComponent, title: 'Order Details', canActivate: [orderManagementGuard] }, // Detail view at /dashboard/orders/:id
          { 
            path: 'repack/create', 
            component: RepackCreateComponent 
            // You can add guards here if needed, e.g., canActivate: [AuthGuard]
          },
           // Update this route
          {
            path: 'repack/update/:id',
            component: RepackUpdateComponent,
            canActivate: [authGuard, orderManagementGuard]
          },
            // Alternative route using shopee number
          {
            path: 'repack/update-by-shopee/:shopeeNo',
            component: RepackUpdateComponent,
            canActivate: [authGuard, orderManagementGuard]
          },

          // Add this route for repack-add-to-existing
          {
            path: 'repack-add-to-existing',
            component: RepackAddToExistingComponent,
            canDeactivate: [canDeactivateRepackAddToExisting],
            canActivate: [authGuard, orderManagementGuard]
          },
          {
            path: 'repack/add-parcels/:cartonNo',
            component: RepackAddParcelsComponent,
            canActivate: [authGuard, orderManagementGuard]
          },
          
          // Pre-Alerts Management
          {
            path: 'pre-alerts',
            canActivate: [authGuard, orderManagementGuard],
            children: [
              { path: '', component: PreAlertList, title: 'Pre-Alerts' },
              { path: ':id', component: PreAlertDetail, title: 'Pre-Alert Details' }
            ]
          },
          
          // Manifest Management
          {
            path: 'manifest',
            component: ManifestComponent,
            title: 'Customs Manifest',
            canActivate: [authGuard, orderManagementGuard]
          },
          
          // Customs Clearance
          {
            path: 'customs-clearance',
            component: CustomsClearanceComponent,
            title: 'Customs Clearance',
            canActivate: [authGuard, orderManagementGuard]
          },

          // Customs Clearance Progress
          {
            path: 'customs-clearance-progress',
            component: CustomsClearanceProgressComponent,
            title: 'Customs Clearance Progress',
            canActivate: [authGuard, orderManagementGuard]
          },
          
          // XML Template Management (Admin Only)
          {
            path: 'template-management',
            component: TemplateManagementComponent,
            title: 'XML Template Management',
            canActivate: [authGuard, adminGuard]
          },
          
          // Integration Management (Admin Only)
          {
            path: 'integration-management',
            component: IntegrationManagementComponent,
            title: 'Integration Management',
            canActivate: [authGuard, adminGuard]
          },
          
          // System Health Monitoring (Admin Only)
          {
            path: 'system-health',
            component: SystemHealthComponent,
            title: 'System Health Monitoring',
            canActivate: [authGuard, adminGuard]
          },
          
          // Excel Upload Demo (for testing)
          {
            path: 'excel-upload-demo',
            component: ExcelUploadDemoComponent,
            title: 'Excel Upload Demo',
            canActivate: [authGuard]
          },
          
          // Barcode Scanner Demo (redirects to mobile scanner)
          {
            path: 'barcode-scanner-demo',
            redirectTo: 'mobile-scanner',
            pathMatch: 'full'
          },
          
          // SignalR Real-time Demo (for testing)
          {
            path: 'signalr-demo',
            component: SignalRDemoComponent,
            title: 'SignalR Real-time Demo',
            canActivate: [authGuard]
          },
          
          // Responsive Design Demo (for testing)
          {
            path: 'responsive-demo',
            component: ResponsiveDemoComponent,
            title: 'Responsive Design Demo',
            canActivate: [authGuard]
          },
          
          // Offline Capability Demo (for testing)
          {
            path: 'offline-demo',
            component: OfflineDemoComponent,
            title: 'Offline Capability Demo',
            canActivate: [authGuard]
          },

          // Phase 1B: Data Table component demo (QA page — remove after UAT)
          {
            path: 'data-table-demo',
            loadComponent: () =>
              import('./shared/components/data-table/data-table-demo.component').then(
                (m) => m.DataTableDemoComponent
              ),
            title: 'DataTable Component Demo',
            canActivate: [authGuard]
          },
          
          // Mobile Carton Scanner (Warehouse operations)
          {
            path: 'mobile-scanner',
            component: MobileCartonScannerComponent,
            title: 'Mobile Carton Scanner',
            canActivate: [authGuard, warehouseGuard]
          },
          
          // Shopee Excel Upload (ShopeeDocsTeam only)
          {
            path: 'shopee-excel-upload',
            component: ShopeeExcelUploadComponent,
            title: 'Shopee Document Upload',
            canActivate: [authGuard, shopeeDocsGuard]
          },

          // Forwarding Module Routes (Admin Only)
          {
            path: 'forwarding',
            canActivate: [authGuard, forwardingUserGuard], // All forwarding users can access
            children: [
              { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
              {
                path: 'dashboard',
                component: ForwardingDashboardComponent,
                title: 'Forwarding Dashboard',
                canActivate: [forwardingUserGuard] // Dashboard: All forwarding users
              },
              {
                path: 'inquiries',
                component: InquiryListComponent,
                title: 'Inquiries',
                canActivate: [forwardingUserGuard] // Inquiries: All forwarding users
              },
              {
                path: 'inquiries/new',
                component: InquiryFormComponent,
                title: 'New Inquiry',
                canActivate: [forwardingUserGuard] // New Inquiry: All forwarding users
              },
              {
                path: 'inquiries/:id',
                component: InquiryFormComponent,
                title: 'Edit Inquiry',
                canActivate: [forwardingUserGuard] // Edit Inquiry: All forwarding users
              },
              // Wave 1 design migration: legacy /quotes paths redirect to canonical /quotations
              // Preserved as redirects so any bookmarks / external links continue to work.
              {
                path: 'quotes',
                redirectTo: 'quotations',
                pathMatch: 'full',
              },
              {
                path: 'quotes/new',
                redirectTo: 'quotations/new',
                pathMatch: 'full',
              },
              {
                path: 'quotes/:id',
                redirectTo: 'quotations/:id',
              },
              {
                path: 'admin',
                component: ForwardingAdminComponent,
                title: 'Forwarding Admin',
                canActivate: [forwardingAdminGuard] // Admin: ForwardingAdmin only
              },
              {
                path: 'admin/quote-templates/edit/:id',
                component: EditQuoteTemplateComponent,
                title: 'Edit Quote Template',
                canActivate: [forwardingAdminGuard] // Edit Template: ForwardingAdmin only
              },
              // Phase 1E: Simplified Quotation System — full list/form/detail flow
              // Guard removed: redundant — the `forwarding` ancestor route (~line 241) already carries
              // [authGuard, forwardingUserGuard], which runs on activation of every descendant in this subtree.
              {
                path: 'quotations',
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/quotations/quotations-list/quotations-list.component').then(
                        (m) => m.QuotationsListComponent
                      ),
                    title: 'Quotations',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/quotations/quotation-form/quotation-form.component').then(
                        (m) => m.QuotationFormComponent
                      ),
                    title: 'New Quotation',
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/quotations/quotation-detail/quotation-detail.component').then(
                        (m) => m.QuotationDetailComponent
                      ),
                    title: 'Quotation Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/quotations/quotation-form/quotation-form.component').then(
                        (m) => m.QuotationFormComponent
                      ),
                    title: 'Edit Quotation',
                  },
                ],
              },
              // Phase 1C — Vendors admin pages
              {
                path: 'vendors',
                canActivate: [forwardingUserGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/vendors/vendors-list/vendors-list.component').then(
                        (m) => m.VendorsListComponent
                      ),
                    title: 'Vendors',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/vendors/vendor-form/vendor-form.component').then(
                        (m) => m.VendorFormComponent
                      ),
                    title: 'New Vendor',
                    canActivate: [forwardingAdminGuard],
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/vendors/vendor-detail/vendor-detail.component').then(
                        (m) => m.VendorDetailComponent
                      ),
                    title: 'Vendor Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/vendors/vendor-form/vendor-form.component').then(
                        (m) => m.VendorFormComponent
                      ),
                    title: 'Edit Vendor',
                    canActivate: [forwardingAdminGuard],
                  },
                ],
              },
              // Phase 1D — Ports admin pages
              {
                path: 'ports',
                canActivate: [forwardingUserGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/ports/ports-list/ports-list.component').then(
                        (m) => m.PortsListComponent
                      ),
                    title: 'Ports',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/ports/port-form/port-form.component').then(
                        (m) => m.PortFormComponent
                      ),
                    title: 'New Port',
                    canActivate: [forwardingAdminGuard],
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/ports/port-detail/port-detail.component').then(
                        (m) => m.PortDetailComponent
                      ),
                    title: 'Port Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/ports/port-form/port-form.component').then(
                        (m) => m.PortFormComponent
                      ),
                    title: 'Edit Port',
                    canActivate: [forwardingAdminGuard],
                  },
                ],
              },
              // Phase 1D — Incoterms admin pages
              {
                path: 'incoterms',
                canActivate: [forwardingUserGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/incoterms/incoterms-list/incoterms-list.component').then(
                        (m) => m.IncotermsListComponent
                      ),
                    title: 'Incoterms',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/incoterms/incoterm-form/incoterm-form.component').then(
                        (m) => m.IncotermFormComponent
                      ),
                    title: 'New Incoterm',
                    canActivate: [forwardingAdminGuard],
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/incoterms/incoterm-detail/incoterm-detail.component').then(
                        (m) => m.IncotermDetailComponent
                      ),
                    title: 'Incoterm Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/incoterms/incoterm-form/incoterm-form.component').then(
                        (m) => m.IncotermFormComponent
                      ),
                    title: 'Edit Incoterm',
                    canActivate: [forwardingAdminGuard],
                  },
                ],
              },
              // Phase 1D — Container Load Types admin pages
              {
                path: 'container-load-types',
                canActivate: [forwardingUserGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/container-load-types/container-load-types-list/container-load-types-list.component').then(
                        (m) => m.ContainerLoadTypesListComponent
                      ),
                    title: 'Container Load Types',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/container-load-types/container-load-type-form/container-load-type-form.component').then(
                        (m) => m.ContainerLoadTypeFormComponent
                      ),
                    title: 'New Container Load Type',
                    canActivate: [forwardingAdminGuard],
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/container-load-types/container-load-type-detail/container-load-type-detail.component').then(
                        (m) => m.ContainerLoadTypeDetailComponent
                      ),
                    title: 'Container Load Type Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/container-load-types/container-load-type-form/container-load-type-form.component').then(
                        (m) => m.ContainerLoadTypeFormComponent
                      ),
                    title: 'Edit Container Load Type',
                    canActivate: [forwardingAdminGuard],
                  },
                ],
              },
              // Unit Bases admin pages (ForwardingAdmin only for writes; ForwardingAdmin gates route)
              {
                path: 'unit-bases',
                canActivate: [forwardingAdminGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/unit-bases/unit-bases-list/unit-bases-list.component').then(
                        (m) => m.UnitBasesListComponent
                      ),
                    title: 'Unit Bases',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/unit-bases/unit-basis-form/unit-basis-form.component').then(
                        (m) => m.UnitBasisFormComponent
                      ),
                    title: 'New Unit Basis',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/unit-bases/unit-basis-form/unit-basis-form.component').then(
                        (m) => m.UnitBasisFormComponent
                      ),
                    title: 'Edit Unit Basis',
                  },
                ],
              },

              // Phase 1K — Quotation Templates admin pages
              {
                path: 'quotation-templates',
                canActivate: [forwardingAdminGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/quotation-templates/quotation-templates-list/quotation-templates-list.component').then(
                        (m) => m.QuotationTemplatesListComponent
                      ),
                    title: 'Quotation Templates',
                  },
                  {
                    path: ':code',
                    loadComponent: () =>
                      import('./components/forwarding/quotation-templates/quotation-template-detail/quotation-template-detail.component').then(
                        (m) => m.QuotationTemplateDetailComponent
                      ),
                    title: 'Quotation Template Detail',
                  },
                ],
              },
              // Phase 1C — Charges admin pages (unified catalog with chargeCode filter chips)
              {
                path: 'charges',
                canActivate: [forwardingUserGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/charges/charges-list/charges-list.component').then(
                        (m) => m.ChargesListComponent
                      ),
                    title: 'All Charges',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/charges/charge-form/charge-form.component').then(
                        (m) => m.ChargeFormComponent
                      ),
                    title: 'New Charge',
                    canActivate: [forwardingAdminGuard],
                  },
                  // Sidebar shortcuts: redirect sub-paths to list with chargeCode query param
                  {
                    path: 'customs-brokerage',
                    redirectTo: '/dashboard/forwarding/charges?chargeCode=CB',
                    pathMatch: 'full',
                  },
                  {
                    path: 'warehouse',
                    redirectTo: '/dashboard/forwarding/charges?chargeCode=WC',
                    pathMatch: 'full',
                  },
                  {
                    path: 'trucking',
                    redirectTo: '/dashboard/forwarding/charges?chargeCode=OT',
                    pathMatch: 'full',
                  },
                  {
                    path: 'other',
                    redirectTo: '/dashboard/forwarding/charges?chargeCode=OC',
                    pathMatch: 'full',
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/charges/charge-detail/charge-detail.component').then(
                        (m) => m.ChargeDetailComponent
                      ),
                    title: 'Charge Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/charges/charge-form/charge-form.component').then(
                        (m) => m.ChargeFormComponent
                      ),
                    title: 'Edit Charge',
                    canActivate: [forwardingAdminGuard],
                  },
                ],
              },
              // Phase 1S — Merged Rates page (canonical URL)
              {
                path: 'rates',
                canActivate: [forwardingUserGuard],
                loadComponent: () =>
                  import('./components/forwarding/rates-page/rates-page.component').then(
                    (m) => m.RatesPageComponent
                  ),
                title: 'Rates',
              },
              // Phase 1G → Phase 1S backward-compat routes (bookmarks / direct links survive)
              {
                path: 'buy-rates',
                canActivate: [forwardingUserGuard],
                loadComponent: () =>
                  import('./components/forwarding/rates-page/rates-page.component').then(
                    (m) => m.RatesPageComponent
                  ),
                title: 'Buy Rates',
                data: { tab: 'buy-rates' },
              },
              {
                path: 'sell-rates',
                canActivate: [forwardingUserGuard],
                loadComponent: () =>
                  import('./components/forwarding/rates-page/rates-page.component').then(
                    (m) => m.RatesPageComponent
                  ),
                title: 'Sell Rates',
                data: { tab: 'sell-rates' },
              },
              // Phase 1G — Markup Config
              {
                path: 'markup-config',
                canActivate: [forwardingAdminGuard],
                loadComponent: () =>
                  import('./components/forwarding/markup-config/markup-config.component').then(
                    (m) => m.MarkupConfigComponent
                  ),
                title: 'Markup Configuration',
              },
              // ADR-008 Phase 2 — Customs Brokerage / Customs Processes
              {
                path: 'customs-processes',
                canActivate: [forwardingAdminGuard],
                children: [
                  {
                    path: '',
                    loadComponent: () =>
                      import('./components/forwarding/customs-processes/customs-processes-list/customs-processes-list.component').then(
                        (m) => m.CustomsProcessesListComponent
                      ),
                    title: 'Customs Brokerage',
                  },
                  {
                    path: 'new',
                    loadComponent: () =>
                      import('./components/forwarding/customs-processes/customs-process-form/customs-process-form.component').then(
                        (m) => m.CustomsProcessFormComponent
                      ),
                    title: 'New Customs Process',
                  },
                  {
                    path: ':id',
                    loadComponent: () =>
                      import('./components/forwarding/customs-processes/customs-process-detail/customs-process-detail.component').then(
                        (m) => m.CustomsProcessDetailComponent
                      ),
                    title: 'Customs Process Detail',
                  },
                  {
                    path: ':id/edit',
                    loadComponent: () =>
                      import('./components/forwarding/customs-processes/customs-process-form/customs-process-form.component').then(
                        (m) => m.CustomsProcessFormComponent
                      ),
                    title: 'Edit Customs Process',
                  },
                ],
              },

              // Settings sub-group
              {
                path: 'settings',
                canActivate: [forwardingAdminGuard],
                children: [
                  {
                    path: '',
                    redirectTo: 'exchange-rates',
                    pathMatch: 'full'
                  },
                  {
                    path: 'exchange-rates',
                    component: ForwardingPlaceholderComponent,
                    title: 'Exchange Rates',
                    data: { title: 'Exchange Rates' }
                  },
                  {
                    path: 'charge-basis',
                    component: ForwardingPlaceholderComponent,
                    title: 'Charge Basis',
                    data: { title: 'Charge Basis' }
                  },
                  {
                    path: 'marine-insurance',
                    component: ForwardingPlaceholderComponent,
                    title: 'Marine Insurance Config',
                    data: { title: 'Marine Insurance Config' }
                  }
                ]
              }
            ]
          },

          // TEMPORARILY DISABLED - Document management routes
          /*
          {
            path: 'documents',
            canActivate: [authGuard, orderManagementGuard],
            children: [
              { path: '', redirectTo: 'manage', pathMatch: 'full' },
              {
                path: 'manage',
                children: [
                  { path: '', component: DocumentListComponent, title: 'Shipping Documents - View' },
                  { path: ':id', component: DocumentDetailComponent, title: 'Document Details' }
                ]
              }
            ]
          },
          */
        ]
      },
      { 
        // Wildcard route, 404 page
        path: '**', 
        component: PageNotFoundComponent 
      }
];
